// extracted by mini-css-extract-plugin
export var fontFamilyHeader = "drawer-module--font-family-header--11nOv";
export var btn = "drawer-module--btn--2kURO";
export var contentContainer = "drawer-module--content-container--1Zy9t";
export var MobileMenuDrawer = "drawer-module--MobileMenuDrawer--GiGCD";
export var MobileMenuDrawerActive = "drawer-module--MobileMenuDrawerActive--1h2BY";
export var DrawerList = "drawer-module--DrawerList--2tv0e";